/**
 * Утилиты для санитизации HTML и защиты от XSS
 */
import DOMPurify from 'dompurify';

/**
 * Конфигурация DOMPurify для Creator Platform
 * Разрешает безопасные теги для форматирования markdown
 */
const SAFE_CONFIG = {
  ALLOWED_TAGS: [
    'p', 'br', 'strong', 'em', 'b', 'i', 'u', 'del', 'code', 'span',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'ul', 'ol', 'li', 'dl', 'dt', 'dd',
    'blockquote', 'pre',
    'table', 'thead', 'tbody', 'tfoot', 'tr', 'td', 'th',
    'a', 'hr', 'div',
  ] as string[],
  ALLOWED_ATTR: ['href', 'title', 'target', 'rel', 'class', 'id'] as string[],
  // Запрещаем опасные протоколы
  FORBID_ATTR: ['style', 'onerror', 'onclick', 'onload', 'onmouseover'] as string[],
  FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form', 'input'] as string[],
  RETURN_TRUSTED_TYPE: false as const,
};

/**
 * Основная функция санитизации с поддержкой безопасных markdown тегов
 * @param dirty - HTML строка, которая может содержать XSS
 * @returns Безопасный HTML
 */
export function sanitizeHtml(dirty: string): string {
  if (!dirty || typeof dirty !== 'string') {
    return '';
  }

  return DOMPurify.sanitize(dirty, SAFE_CONFIG) as string;
}

/**
 * Escape HTML специальных символов (для использования в text nodes)
 * @param text - текст для экранирования
 * @returns Экранированный текст
 */
export function escapeHtml(text: string): string {
  if (!text || typeof text !== 'string') {
    return '';
  }

  const map: Record<string, string> = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;',
  };
  return text.replace(/[&<>"']/g, (char) => map[char] || char);
}
